import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";

const TextButton = (props) => {
  const classes = useStyles();

  return (
    <Button
      disableRipple
      className={classes.TextButton}
      {...props}
    >
      {props.children}
    </Button>
  );
};

export default TextButton;

const useStyles = makeStyles((theme) => ({
  TextButton: {
    color: "var(--teal-700)",
    transition: "background-color 0.2s ease",
    fontWeight: "normal",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    "&:active": {
      backgroundColor: "var(--teal-300)",
    },
    "&:focus": {
      outline: "1px solid var(--teal-500)",
      outlineOffset: "4px",
    },
  },
}));
